var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInnerHeroLogoMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 187
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-hero-logo-mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4795",
    transform: "translate(285 360)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h90v187H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 78",
    transform: "translate(-285 -360)",
    clipPath: "url(#inner-hero-logo-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 119",
    d: "M399.223 541l66.18-114.626-114.626-66.18-23.168 40.13 11.526 6.654 16.513-28.602 91.574 52.87-52.87 91.574-91.574-52.87 15.146-26.233 35.672-9.556-3.445-12.858-38.334 10.272-2.672.73-24.547 42.516z",
    fill: "#fff",
    opacity: 0.086
  }))));
}

export default __webpack_public_path__ + "79cacfac929cb5cab8f480c8b4d391f2.svg";
export { SvgInnerHeroLogoMobile as ReactComponent };